<template>
    <div class="duiwu">
        <div class="duiwuBox">
            <div class="boxTop">
                <p></p>
                <p> 师资队伍
                </p>
                <p></p>
            </div>
            <div style="display: flex;flex-wrap: wrap;justify-content: space-between;">
                <img  v-for="item in getContentList" :src="item.img" alt="" style="width: 270px;height: 280px;margin-top: 30px;" @click=" openNewAll(item)">
            </div>
        </div>
    </div>
</template>


<script>
export default {
    components: {
    },
    name: "duiwu",
    data() {
        return {
            getContentList:[],
            total: 0,
            currentPage: 1,
            pageSize: 8,
        }
    },
    mounted() {
        this.$axios
            .get("/system/content/getContentList",  { params:{pageNum: this.currentPage, pageSize: this.pageSize, type: '1' }})
            .then(res => {
                if (res.code == 0) {
                this.getContentList = res.data.rows
                } else {
                this.$message.closeAll();
                this.$message.error(res.msg);
                }
            });
    },
    methods: {
        openNewAll(row){
            sessionStorage.setItem("top", '2');
            this.$router.push({
            path: "/teachingStaffDetails",
            query: row
        });
        },
    }
};
</script>

<style lang="less">
.duiwu {
    width: 100%;
    background-image: url("../../../assets/duiwu.jpg");
    background-size: cover;
    /* 背景图片覆盖整个元素 */
    background-repeat: no-repeat;
    /* 背景图片不重复 */
    background-position: center;
    /* 背景图片居中 */
    height: 802px;
    padding: 60px 0;

    .duiwuBox {
        width: 1200px;
        margin: 0 auto;
        .boxTop {
			width: 100%;
			display: flex;
			margin-top: 20px;
			margin-bottom: 20px;
            
		}

		.boxTop p:nth-child(1) {
			width: 42%;
			height: 2px;
			background-image: linear-gradient(to right, #fff, #c8161e);
			margin-top: 15px;
		}

		.boxTop p:nth-child(2) {
			flex: 1;
			font-size: 32px;
			line-height: 30px;
			text-align: center;
		}

		.boxTop p:nth-child(3) {
			width: 42%;
			height: 2px;
			background-image: linear-gradient(to right, #c8161e, #fff);
			margin-top: 15px;
		}
    }
}
</style>